import ArrowClockwise from '../../src/legacy/ArrowClockwise.tsx';
export default ArrowClockwise;
